import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import {
  ChartIconInActive, ChartIconActive,
  TableIconInActive, TableIconActive, LightIcon,
} from '@styled/icon';
import moTimeTrend, {
  initTimeTrend, changeType,
} from './store';
import Chart from './chart';
import CommonTable from './table';
import moIndex, { toggleTip } from '../../store/index';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import { exportExcelFile, newRate, newValue } from '@tool/index';

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: '32px',
  height: '20px',
  marginRight: '2px',
  borderRadius: '3px',
}));

const ActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.primary,
  '&:hover': { backgroundColor: Color.primary },
}));

const InActiveType = styled(DIconButton)(() => ({
  backgroundColor: Color.fff,
  '&:hover': { backgroundColor: Color.fff },
}));

// 涨薪率 - 涨薪率时间趋势
const TimeTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { industry, isMock } = moIndex;
  const {
    type, xData, yData, overview, labels,
    tableLeft, tableRight,
  } = moTimeTrend;
  const descArr = [
    "统计说明：在相同行业、城市组合下，计算各职能月度薪酬的中位数，然后计算月度薪酬的同比变化率，最后计算各统计周期下的变化率均值，即为涨薪率",
    "基于以下指标的涨幅：CPI，行业上市公司的营收、利润和薪酬成本，行业的招聘量和薪酬，生成算法模型。以近半年的数据为输入数据，使用该模型预测下一期的涨薪率。每个季度对涨薪率进行一次预测，上半年预测当年的涨薪率、下半年预测次年的涨薪率。",
    "*此处为不区分城市的涨薪率",
  ];

  const exporttable = () => {
    if (moUser.isIndicatorExpired) {
      toggleTip(true);
      return;
    }
    const list :any =[];
    tableLeft.forEach((item:any,i:any)=>{
       const items:any =[item,...tableRight[i]];
       list.push(items);
    })
    const merge:any = [];
    exportExcelFile(list, merge, '涨薪率时间趋势');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="time-trend_10">
      <section className="box-11">
        <p className="one-11">
          <strong>涨薪率时间趋势</strong>
          <span className="tag-02">{industry.name}</span>
          {type === 'chart' ? (
            <ActiveType>
              <ChartIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('chart')}>
              <ChartIconInActive />
            </InActiveType>
          )}
          {type === 'table' ? (
            <ActiveType>
              <TableIconActive />
            </ActiveType>
          ) : (
            <InActiveType onClick={() => changeType('table')}>
              <TableIconInActive />
            </InActiveType>
          )}
        </p>
        <section className="one-1303">
          <span style={{ color: '#878787' }}><LightIcon color={Color.primary} />&nbsp;关于统计周期，请切换至表格样式，查看各统计周期的时间范围</span>
          <p className="one-166">
            {descArr.map((text: any, ix: number) => (
              <span key={ix}>{text}</span>
            ))}
          </p>
        </section>
      </section>

      {type === 'chart' ? (
        <>
          {!isEmpty(xData) ? (
            <section className="box-13">
              <section className={[
                "box-15",
                !isMock ? '' : 'mock-100',
              ].join(' ')}>
                <section className="chart-title_03">
                  {labels.map((item: any, idx: number) => (
                    <p key={idx} className="line-03" style={{ marginTop: 0 }}>
                      <strong>{newRate(item?.change_rate)}</strong>
                      <span>{item?.date}{item?.industry_lv1}涨薪率</span>
                    </p>
                  ))}
                </section>
                <Chart height={300} xData={xData} yData={yData} />
              </section>
              <section className="box-150">
                <strong>解读：</strong>
                <section className="box-151">
                  {overview.map((text: any, index: number) => (
                    <p key={index}>
                      <span className="ico-11"><b /></span>
                      <i>{text}</i>
                    </p>
                  ))}
                </section>
              </section>
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      ) : (
        <>
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!isEmpty(tableRight) ? (
            <section className="box-30top">
              <CommonTable
                leftList={[tableLeft]}
                rightList={tableRight}
              />
            </section>
          ) : <Empty padding="50px 0" />}
        </>
      )}
    </section>
  );
};

export default observer(TimeTrend);
